import React from 'react';
import '../styles/theme.css';
import '../styles/Integrations.css';
import BruteHeader from '../components/BruteHeader';
import BruteFooter from '../components/BruteFooter';
import IntegrationsMasthead from '../components/IntegrationsMasthead';
import IntegrationsActionStrip from '../components/IntegrationsActionStrip';
import IntegrationsConfigPanel from '../components/IntegrationsConfigPanel';
/* IMPORTS */

function IntegrationsPage() {
  return (
    <div className="in-root">
      <div className="in-layout-1">
        <div id="integrationsheaderslot" className="in-slot-integrationsheaderslot">
          <BruteHeader activePage={"Integrations"} />
        </div>
        <div className="in-layout-2">
          <div id="integrationsmasthead" className="in-slot-integrationsmasthead">
            <IntegrationsMasthead />
          </div>
          <div id="integrationsconfigpanel" className="in-slot-integrationsconfigpanel">
            <IntegrationsConfigPanel />
          </div>
        </div>
        <div id="integrationsactionstrip" className="in-slot-integrationsactionstrip">
          <IntegrationsActionStrip />
        </div>
        <div id="integrationsfooterslot" className="in-slot-integrationsfooterslot">
          <BruteFooter />
        </div>
      </div>
    </div>
  );
}

export default IntegrationsPage;